import React, { useState, useEffect } from "react";
import MessageList from "./MessageList";
import BackBtn from "./Message/BackBtn";
import MessageField from "./Message/MessageField";
import UnPinAllButton from "./PinnedMessages/UnPinAllButton";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import PinnedMSgNotification from "./PinnedMessages/PinnedMSgNotification";
import Box from "@mui/material/Box";
import { parseInt } from "lodash";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";
const queryUrl = BaseURL.baseUrl + BaseURL.widget.GetPinnedMessages;
const MESSAGE_LIMIT = 100; // number of messages to fetch at a time

const defaultMessage = {
  messageId: 0,
  createdOn: null,
  prequalificationId: 0,
  message: null,
  accessType: 1,
  createdByName: null,
  hasAttachment: false,
  attachmentName: null,
  attachmentSize: null,
  attachmentId: null,
  isEdited: false,
  isDeleted: false,
  updatedOnBacked: true,
};

function CommunicationDetails({
  pqId,
  pqDetails,
  setPqId,
  messageListTitle,
  goToCommunicationList,
}) {
  const [messageData, setMessageData] = useState(defaultMessage);
  const [showPinned, setShowPinned] = useState(false);
  const [unPinnedAll, setUnPinnedAll] = useState(false);
  const [lastPinnedMessageTitle, setLastPinnedMessageTitle] = useState("");
  const [pinnedCount, setPinnedCount] = useState(0);
  const [listTitle, setListTitle] = useState(messageListTitle);
  const [uploadComplete, setUploadComplete] = useState(true);
  const navigate = useNavigate();


  useEffect(() => {
    setTimeout(() => {
      const params = new URLSearchParams(window.location.search);
      const PQID = params.get("pqid");
      if (PQID != pqId) {
        navigate("/vendordetails?pqid=" + pqId + "&tab=Questionnaire" + "&Type=3");
      }
    }, 1000);
  }, []);

  useEffect(() => {
    GetPinnedMessages();
  }, [showPinned, unPinnedAll]);

  const onPinChanges = () => {
    setTimeout(() => GetPinnedMessages(), 1000);
  };

  const saveMessageHandler = async (enteredMessage) => {
    if (enteredMessage?.get("File")) setUploadComplete(false);
    const data = await axios.post(
      BaseURL.baseUrl + BaseURL.widget.SaveUpdateMessage,
      enteredMessage,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    if (data.data.responseMessage === "Success") {
      setUploadComplete(true);
      const fileData = enteredMessage?.get("File");
      const isMessageUpdated =
        parseInt(enteredMessage?.get("MessageId")) === data.data.data.messageId;
      setMessageData({
        messageId: data.data.data.messageId,
        createdOn: new Date().toISOString(),
        prequalificationId: enteredMessage.get("PrequalificationId"),
        message: fileData ? "" : enteredMessage?.get("message"),
        accessType: parseInt(enteredMessage?.get("accessType")),
        createdByName: "You",
        hasAttachment: enteredMessage?.get("HasAttachment"),
        attachmentName: fileData?.name,
        attachmentSize: fileData?.size,
        attachmentId: data.data.data.attachmentId,
        isEdited: isMessageUpdated,
        isDeleted: false,
        updatedOnBacked: true,
      });
    } else {
      console.error(data.data);
    }
  };

  const GetPinnedMessages = async () => {
    const response = await axios.get(
      queryUrl +
      "?prequalificationId=" +
      pqId +
      "&pageSize=" +
      MESSAGE_LIMIT +
      "&pageNumber=" +
      1
    );

    if (response.data.data) {
      if (showPinned) {
        setListTitle(`${response.data.data.length > 99 ? '99+' : response.data.data.length} Pinned Messages`);
      } else {
        setListTitle(`${pqDetails?.vendorName}`);
      }
      setLastPinnedMessageTitle(response.data.data[0]?.message);
      setPinnedCount(response.data.data?.length);
    }
  };

  const updatedMessageHandler = (editingMessageData) => {
    if (editingMessageData) {
      setMessageData({
        messageId: editingMessageData.messageId,
        message: editingMessageData.message,
        accessType: editingMessageData.accessType,
        isEdited: true,
        isDeleted: false,
      });
    }
  };

  const deleteMessageHandler = (deletedMessageData) => {
    if (deletedMessageData) {
      setMessageData({
        messageId: deletedMessageData.messageId,
        isEdited: false,
        isDeleted: true,
      });
      deletedMessageData.isPinned && onPinChanges(); // re count total Pinned messages
    }
  };

  const afterMessageDeleteHandler = (isDeleted) => {
    if (isDeleted)
      setMessageData({
        messageId: 0,
        isEdited: false,
        isDeleted: false,
      });
  };

  const onUnpinAllMessages = (isUnpinned) => {
    setListTitle("0 Pinned Messages");
    setUnPinnedAll(true);
  };

  const backClickHandler = (navigateTo) => {
    if (navigateTo === "child") {
      setShowPinned(false);
      setUnPinnedAll(false);
    } else {
      goToCommunicationList();
    }
  };

  return (
    <>

      <Box
        //style={{ overflowX: "hidden", height: "100%" }}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
           position: "relative"
        }}
      >
        <BackBtn
          handleBackClick={backClickHandler}
          listTitle={listTitle}
          clientName={pqDetails.clientName}
          showPinned={showPinned}
        />
        {!showPinned && pinnedCount > 0 && (
          <PinnedMSgNotification
            setShowPinned={setShowPinned}
            title={lastPinnedMessageTitle}
          />
        )}
        <MessageList
          listHeight={`${pinnedCount > 0 ? "calc(53vh - 50px)" : "calc(50vh - 0px)"
            }`}
          onPinChanges={onPinChanges}
          pqId={pqId}
          newMessageData={messageData}
          showPinned={showPinned}
          onSaveUpdatedMessage={updatedMessageHandler}
          onDeleteMessage={deleteMessageHandler}
          unPinnedAll={unPinnedAll}
          afterMessageDelete={afterMessageDeleteHandler}
        />
        {!uploadComplete && (
          <div>
            <LinearProgress />
          </div>
        )}
        <MessageField
          messageData={messageData}
          pqId={pqId}
          onSaveMessage={saveMessageHandler}
          isPinned={showPinned}
          onUnpinAllMessages={onUnpinAllMessages}
          unPinTitle={listTitle}
        />
        {showPinned && (
          <UnPinAllButton
            onUnpinAllMessages={onUnpinAllMessages}
            pqId={pqId}
            unPinTitle={listTitle}
          />
        )}
      </Box >
    </>
  );
}

export default CommunicationDetails;
